import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function BurglarAlarmSystemsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = "Hırsız Alarm Sistemleri Kurulumu İstanbul | Kablosuz Kablolu Alarm";
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İstanbul, Kocaeli, Gebze, Tuzla ve Bursa\'da profesyonel hırsız alarm sistemleri kurulumu. Kablosuz ve kablolu alarm sistemleri, 7/24 izleme merkezi bağlantısı ve mobil bildirim özellikleri.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'İstanbul, Kocaeli, Gebze, Tuzla ve Bursa\'da profesyonel hırsız alarm sistemleri kurulumu. Kablosuz ve kablolu alarm sistemleri, 7/24 izleme merkezi bağlantısı ve mobil bildirim özellikleri.';
      document.head.appendChild(meta);
    }

    // Keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'hırsız alarm sistemi, kablosuz alarm, kablolu alarm, güvenlik alarm kurulumu, fabrika alarm sistemi');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'hırsız alarm sistemi, kablosuz alarm, kablolu alarm, güvenlik alarm kurulumu, fabrika alarm sistemi';
      document.head.appendChild(meta);
    }

    // Open Graph Tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Hırsız Alarm Sistemleri Kurulumu İstanbul | Kablosuz Kablolu Alarm');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'Hırsız Alarm Sistemleri Kurulumu İstanbul | Kablosuz Kablolu Alarm';
      document.head.appendChild(meta);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Fabrika ve sanayi tesisleri için güvenilir hırsız alarm sistemleri. Hareket sensörleri, cam kırılma algılama ve 7/24 izleme merkezi bağlantısı.');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:description');
      meta.content = 'Fabrika ve sanayi tesisleri için güvenilir hırsız alarm sistemleri. Hareket sensörleri, cam kırılma algılama ve 7/24 izleme merkezi bağlantısı.';
      document.head.appendChild(meta);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://fiberek.com/guvenlik-sistemleri/hirsiz-alarm-sistemleri');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      meta.content = 'https://fiberek.com/guvenlik-sistemleri/hirsiz-alarm-sistemleri';
      document.head.appendChild(meta);
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://fiberek.com/guvenlik-sistemleri/hirsiz-alarm-sistemleri');
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = 'https://fiberek.com/guvenlik-sistemleri/hirsiz-alarm-sistemleri';
      document.head.appendChild(link);
    }

    // Cleanup function
    return () => {
      document.title = 'Fiber Optik Ustası';
    };
  }, []);

  const features = [
    { icon: 'ri-wireless-charging-line', title: 'Kablosuz Sensörler', description: 'Kolay kurulum, esnek yerleşim' },
    { icon: 'ri-smartphone-line', title: 'Mobil Bildirim', description: 'Anında SMS ve push bildirimi' },
    { icon: 'ri-map-pin-line', title: 'Bölgesel Kontrol', description: 'Farklı alanlar için ayrı kontrol' },
    { icon: 'ri-shield-check-line', title: 'Sabotaj Koruması', description: 'Kesme ve müdahale algılama' },
    { icon: 'ri-volume-up-line', title: 'Sesli Uyarı', description: 'Yüksek desibel siren sistemi' },
    { icon: 'ri-battery-line', title: 'Yedek Güç', description: 'Elektrik kesintisinde çalışma' }
  ];

  const sensorTypes = [
    {
      title: 'PIR Hareket Sensörleri',
      description: 'Pasif kızılötesi sensörler ile hareket algılama. Geniş açılı algılama, evcil hayvan immunitesi ve ayarlanabilir hassasiyet özellikleri.',
      specs: ['12m algılama mesafesi', '90° algılama açısı', 'Çift teknoloji', 'Pet immunity']
    },
    {
      title: 'Manyetik Kontak Sensörleri',
      description: 'Kapı ve pencere açılma algılama. Gizli veya görünür montaj seçenekleri, yüksek dayanıklılık ve uzun ömür.',
      specs: ['Kapı/pencere koruması', 'Gizli montaj', 'Sabotaj koruması', 'Kablosuz iletişim']
    },
    {
      title: 'Cam Kırılma Sensörleri',
      description: 'Akustik cam kırılma algılama teknolojisi. Tek sensör ile 9 metreye kadar çoklu cam koruma sağlar.',
      specs: ['9m koruma alanı', 'Akustik algılama', 'Çoklu cam koruması', 'Yanlış alarm önleme']
    },
    {
      title: 'Titreşim Sensörleri',
      description: 'Duvar, tavan ve zemin titreşim algılama. Delme, kesme ve zorla giriş girişimlerini tespit eder.',
      specs: ['Yüksek hassasiyet', 'Ayarlanabilir seviye', 'Sabotaj koruması', 'Endüstriyel dayanıklılık']
    }
  ];

  const faqs = [
    {
      question: 'Hırsız alarm sistemleri nasıl çalışır?',
      answer: 'Hırsız alarm sistemleri, sensörler aracılığıyla izinsiz giriş girişimlerini algılar ve alarm verir. Sistem, hareket sensörleri, manyetik kontaklar, cam kırılma sensörleri ve titreşim sensörleri gibi farklı algılama cihazlarından oluşur. Sensörlerden biri tetiklendiğinde, alarm paneli devreye girer, siren çalar ve önceden tanımlı kişilere SMS veya mobil bildirim gönderilir. Aynı zamanda güvenlik şirketine veya polis merkezine otomatik ihbar yapılabilir.'
    },
    {
      question: 'Kablosuz alarm sistemleri güvenilir midir?',
      answer: 'Evet, modern kablosuz alarm sistemleri son derece güvenilirdir. Şifreli RF (radyo frekansı) iletişim protokolleri kullanarak sensörler ve panel arasında güvenli veri aktarımı sağlar. Kablosuz sistemler, kablo kesme sabotajına karşı daha dayanıklıdır. Pil ömrü genellikle 2-3 yıldır ve düşük pil durumunda sistem uyarı verir. Ayrıca, sinyal kesintisi veya müdahale girişimlerinde de alarm tetiklenir.'
    },
    {
      question: 'Hırsız alarm sistemi kurulumu ne kadar sürer?',
      answer: 'Kurulum süresi, korunacak alanın büyüklüğüne ve sensör sayısına bağlıdır. Küçük ofisler ve işletmeler için kurulum 4-6 saat sürer. Orta ölçekli fabrika ve sanayi tesisleri için 1-2 gün, büyük ölçekli kurumsal projeler için 3-5 gün gerekebilir. Kablosuz sistemler daha hızlı kurulur. Kurulum sonrası sistem testleri yapılır ve kullanıcı eğitimi verilir.'
    },
    {
      question: 'Alarm sistemi yanlış alarm verir mi?',
      answer: 'Modern alarm sistemleri, yanlış alarm oranını minimize eden gelişmiş teknolojiler kullanır. Çift teknoloji sensörler (PIR + mikrodalga), evcil hayvan immunitesi, ayarlanabilir hassasiyet ve akıllı algılama algoritmaları ile yanlış alarmlar önlenir. Doğru kurulum ve kalibrasyonla yanlış alarm riski çok düşüktür. Sistemimiz, kullanıcı hatalarını önlemek için çıkış gecikmesi ve giriş gecikmesi ayarları sunar.'
    },
    {
      question: 'Alarm sistemi elektrik kesintisinde çalışır mı?',
      answer: 'Evet, tüm alarm sistemlerimiz yedek pil ile donatılmıştır. Elektrik kesintisi durumunda sistem otomatik olarak yedek güç kaynağına geçer ve 12-24 saat boyunca kesintisiz çalışmaya devam eder. Elektrik kesildiğinde sistem yöneticisine bildirim gönderilir. Yedek pil düzenli olarak kontrol edilir ve gerektiğinde değiştirilir.'
    },
    {
      question: 'Hangi bölgelerde hırsız alarm sistemleri kurulumu yapıyorsunuz?',
      answer: 'İstanbul Avrupa Yakası, İstanbul Anadolu Yakası, Ataşehir, Kadıköy, Ümraniye, Esenyurt, Başakşehir, Pendik, Kartal, Beylikdüzü, Tuzla, Gebze, Dilovası, Çayırova, Kocaeli, Sakarya, Yalova, Bursa, Tekirdağ ve Çorlu bölgelerinde hırsız alarm sistemleri kurulumu hizmeti veriyoruz. Fabrika, sanayi tesisi, OSB ve kurumsal işletmelere özel çözümler sunuyoruz.'
    }
  ];

  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/062dceac7dd9463d377f99089aa84386.jpg"
            alt="Hırsız Alarm Sistemleri"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/90 via-slate-950/85 to-slate-950"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <nav className="flex items-center gap-2 text-sm text-gray-400 mb-8">
            <Link to="/" className="hover:text-orange-400 transition-colors cursor-pointer">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/guvenlik-sistemleri" className="hover:text-orange-400 transition-colors cursor-pointer">Güvenlik Sistemleri</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-orange-400">Hırsız Alarm Sistemleri</span>
          </nav>

          <div className="max-w-4xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-600/20 border border-orange-500/30 rounded-full mb-6">
              <i className="ri-alarm-warning-line text-orange-400 text-lg"></i>
              <span className="text-orange-300 text-sm font-medium">Güvenilir Alarm Sistemleri</span>
            </div>

            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Hırsız Alarm Sistemleri Kurulumu
            </h1>

            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              İstanbul, Kocaeli, Gebze, Tuzla, Bursa ve çevre illerde fabrika, sanayi tesisi ve kurumsal işletmeler için profesyonel hırsız alarm sistemleri kurulumu. Kablosuz ve kablolu alarm sistemleri, 7/24 izleme merkezi bağlantısı ve mobil bildirim özellikleri.
            </p>

            <div className="flex flex-wrap items-center gap-4">
              <a
                href="tel:+905537165561"
                className="px-8 py-4 bg-gradient-to-r from-orange-600 to-amber-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-orange-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                Hemen Ara
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-green-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp Destek
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-slate-900/30">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <article className="prose prose-invert prose-lg max-w-none">
              <h2 className="text-3xl font-bold text-white mb-6">Hırsız Alarm Sistemleri Nedir?</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Hırsız alarm sistemleri, izinsiz giriş girişimlerini algılayan ve uyarı veren elektronik güvenlik sistemleridir. Hareket sensörleri, manyetik kontaklar, cam kırılma sensörleri ve titreşim sensörleri gibi farklı algılama cihazları kullanarak, korunan alanı 7/24 izler. Bir sensör tetiklendiğinde, alarm paneli devreye girer, yüksek desibel siren çalar ve önceden tanımlı kişilere anında bildirim gönderilir.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Fabrika, sanayi tesisi, ofis ve kurumsal işletmelerde hırsız alarm sistemleri kurulumu, güvenlik önlemlerinin en önemli parçasıdır. İstanbul, Kocaeli, Gebze, Tuzla, Bursa ve çevre illerde profesyonel hırsız alarm sistemleri kurulumu hizmeti veriyoruz. TSE ve CE onaylı ekipmanlar kullanarak, güvenilir ve yüksek performanslı alarm sistemleri kuruyoruz.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Hırsız Alarm Sistemlerinin Özellikleri</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 not-prose">
                {features.map((feature, index) => (
                  <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-orange-500/50 transition-all duration-300">
                    <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-600 to-amber-600 rounded-lg mb-4">
                      <i className={`${feature.icon} text-2xl text-white`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                    <p className="text-gray-400 text-sm">{feature.description}</p>
                  </div>
                ))}
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Alarm Sensör Türleri</h2>
              <div className="space-y-6 mb-8 not-prose">
                {sensorTypes.map((sensor, index) => (
                  <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-orange-500/50 transition-all duration-300">
                    <h3 className="text-2xl font-bold text-white mb-3">{sensor.title}</h3>
                    <p className="text-gray-300 leading-relaxed mb-4">{sensor.description}</p>
                    <div className="flex flex-wrap gap-3">
                      {sensor.specs.map((spec, idx) => (
                        <span key={idx} className="px-3 py-1 bg-orange-600/20 border border-orange-500/30 rounded-full text-orange-300 text-sm">
                          {spec}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Hırsız Alarm Sistemi Kurulum Süreci</h2>
              <div className="space-y-6 mb-8 not-prose">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-600 to-amber-600 rounded-full text-white font-bold">1</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Güvenlik Analizi</h3>
                    <p className="text-gray-300">Tesiste detaylı güvenlik analizi yapılır. Riskli noktalar belirlenir, giriş-çıkış noktaları, pencereler ve kritik alanlar tespit edilir.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-600 to-amber-600 rounded-full text-white font-bold">2</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Sistem Tasarımı</h3>
                    <p className="text-gray-300">İhtiyaca göre sensör türleri ve sayısı belirlenir. Kablosuz veya kablolu sistem seçimi yapılır. Bölgesel kontrol planlaması yapılır.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-600 to-amber-600 rounded-full text-white font-bold">3</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Kurulum ve Montaj</h3>
                    <p className="text-gray-300">Alarm paneli monte edilir, sensörler stratejik noktalara yerleştirilir. Kablolu sistemlerde kablo altyapısı döşenir, kablosuz sistemlerde RF sinyalleri test edilir.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-600 to-amber-600 rounded-full text-white font-bold">4</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Programlama ve Yapılandırma</h3>
                    <p className="text-gray-300">Alarm paneli programlanır, bölgeler tanımlanır, kullanıcı kodları oluşturulur. Mobil bildirim ve izleme merkezi bağlantısı yapılandırılır.</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-600 to-amber-600 rounded-full text-white font-bold">5</div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Test ve Eğitim</h3>
                    <p className="text-gray-300">Tüm sensörler tek tek test edilir, alarm senaryoları simüle edilir. Kullanıcılara sistem kullanımı, devreye alma/devre dışı bırakma ve acil durum prosedürleri hakkında eğitim verilir.</p>
                  </div>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Kablosuz ve Kablolu Alarm Sistemleri Karşılaştırması</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                <strong className="text-white">Kablosuz Alarm Sistemleri:</strong> Kolay ve hızlı kurulum, esnek yerleşim, kablo kesme sabotajına karşı dayanıklılık, tarihi binalarda ideal, genişletmeye açık yapı. Pil değişimi gerektirir ancak modern sistemlerde pil ömrü 2-3 yıldır. Fabrika ve sanayi tesislerinde retrofit projeler için mükemmel çözümdür.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                <strong className="text-white">Kablolu Alarm Sistemleri:</strong> Sürekli güç kaynağı, pil değişimi gerektirmez, RF sinyal parazitinden etkilenmez, büyük tesislerde güvenilir iletişim. Kurulum daha uzun sürer ve kablo altyapısı gerektirir. Yeni inşa edilen fabrika ve sanayi tesislerinde tercih edilir. Her iki sistem türü de yüksek güvenlik sağlar ve ihtiyaca göre seçim yapılır.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Sanayi ve Fabrika Uygulamaları</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Fabrika ve sanayi tesislerinde hırsız alarm sistemleri, sadece hırsızlık önleme değil, aynı zamanda yetkisiz alan erişimini engellemek için de kullanılır. Üretim hatları, hammadde depoları, bitmiş ürün alanları, makine parkları ve idari ofisler için farklı güvenlik seviyeleri tanımlanabilir. Mesai saatleri dışında tüm tesis korunurken, mesai saatlerinde sadece kritik alanlar aktif tutulabilir.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Alarm sistemleri, geçiş kontrol sistemleri ve IP kamera sistemleri ile entegre çalışarak kapsamlı bir güvenlik ekosistemi oluşturur. Örneğin, alarm tetiklendiğinde ilgili bölgedeki kameralar otomatik olarak kayda başlar ve güvenlik personeline canlı görüntü iletilir. İstanbul, Kocaeli, Gebze, Tuzla ve Bursa bölgelerindeki sanayi tesislerine özel çözümler sunuyoruz.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">İzleme Merkezi Entegrasyonu</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Hırsız alarm sistemlerimiz, 7/24 izleme merkezine bağlanabilir. Alarm tetiklendiğinde, izleme merkezi operatörleri anında bilgilendirilir ve gerekli müdahale başlatılır. IP/GPRS iletişim modülleri ile alarm sinyalleri şifreli olarak iletilir. İzleme merkezi, yanlış alarm kontrolü yapar, gerektiğinde polis veya özel güvenlik ekiplerini yönlendirir.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                Mobil uygulama üzerinden de alarm durumunu takip edebilir, sistemi uzaktan devreye alabilir veya devre dışı bırakabilirsiniz. Alarm geçmişi, sensör durumları ve sistem sağlığı hakkında detaylı raporlar alabilirsiniz. Fabrika yöneticileri ve güvenlik personeli için farklı yetki seviyeleri tanımlanabilir.
              </p>

              <h2 className="text-3xl font-bold text-white mb-6 mt-12">Bakım ve Destek Hizmetleri</h2>
              <p className="text-gray-300 leading-relaxed mb-6">
                Hırsız alarm sistemleri kurulumu sonrasında düzenli bakım ve destek hizmeti sunuyoruz. Yıllık bakım sözleşmeleri ile sensör testleri, pil kontrolleri, yazılım güncellemeleri ve sistem optimizasyonu yapılır. Arızalı sensör değişimi, panel bakımı ve sistem genişletme hizmetleri de mevcuttur.
              </p>
              <p className="text-gray-300 leading-relaxed mb-8">
                7/24 teknik destek hattımız ile her türlü sorun anında çözülür. İstanbul Avrupa Yakası, İstanbul Anadolu Yakası, Tuzla, Gebze, Kocaeli, Bursa ve diğer bölgelerde hızlı servis hizmeti veriyoruz. Acil durumlarda aynı gün müdahale garantisi sağlıyoruz. Tüm kurulumlarımız 2 yıl garanti kapsamındadır.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-white text-center mb-12">
              Sıkça Sorulan Sorular
            </h2>

            <div className="space-y-6">
              {faqs.map((faq, index) => (
                <details key={index} className="group bg-slate-900/50 border border-slate-800 rounded-xl overflow-hidden hover:border-orange-500/50 transition-all duration-300">
                  <summary className="flex items-center justify-between p-6 cursor-pointer list-none">
                    <h3 className="text-xl font-bold text-white pr-4">{faq.question}</h3>
                    <i className="ri-arrow-down-s-line text-2xl text-orange-400 group-open:rotate-180 transition-transform duration-300"></i>
                  </summary>
                  <div className="px-6 pb-6">
                    <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-20 bg-slate-900/30">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-white text-center mb-12">
              Diğer Güvenlik Sistemleri Hizmetlerimiz
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Link to="/guvenlik-sistemleri/ip-kamera-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-red-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-600 to-orange-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-camera-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-red-400 transition-colors">IP Kamera Sistemleri</h3>
                <p className="text-gray-400 text-sm">4K Ultra HD kamera kurulumu ve izleme</p>
              </Link>

              <Link to="/guvenlik-sistemleri/yangin-alarm-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-red-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-red-700 to-red-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-fire-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-red-400 transition-colors">Yangın Alarm Sistemleri</h3>
                <p className="text-gray-400 text-sm">TSE onaylı yangın algılama sistemleri</p>
              </Link>

              <Link to="/guvenlik-sistemleri/gecis-kontrol-sistemleri" className="group bg-slate-800/50 border border-slate-700 rounded-xl p-6 hover:border-cyan-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-blue-600 to-cyan-600 rounded-lg mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-door-lock-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-cyan-400 transition-colors">Geçiş Kontrol Sistemleri</h3>
                <p className="text-gray-400 text-sm">Kartlı ve biyometrik geçiş sistemleri</p>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-orange-600/20 to-amber-600/20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Hırsız Alarm Sistemi Kurulumu İçin Hemen İletişime Geçin
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Ücretsiz keşif ve teknik danışmanlık için bizi arayın. Profesyonel ekibimiz size en uygun çözümü sunar.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a
                href="tel:+905537165561"
                className="px-8 py-4 bg-gradient-to-r from-orange-600 to-amber-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-orange-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                +90 553 716 55 61
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-green-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </div>
  );
}
